import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=65e53d2b&scoped=true&"
import script from "./NavigationItems.vue?vue&type=script&lang=ts&"
export * from "./NavigationItems.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=65e53d2b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e53d2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e53d2b')) {
      api.createRecord('65e53d2b', component.options)
    } else {
      api.reload('65e53d2b', component.options)
    }
    module.hot.accept("./NavigationItems.vue?vue&type=template&id=65e53d2b&scoped=true&", function () {
      api.rerender('65e53d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Navigation/NavigationItems.vue"
export default component.exports